module.exports = __webpack_public_path__ + "static/media/4ODA13.df75d639.jpg";